import Link from 'next/link'
// icon
import CrossmarkIcon from 'public/icons/interface/crossmark.svg'
// end icon
export default function Crossmark({ doi }) {
  return (
    <Link href={`https://crossmark.crossref.org/dialog/?doi=${doi}`} target="_blank" rel="noopener noreferrer">
      <CrossmarkIcon />
    </Link>
  )
}
